import styled, { keyframes } from 'styled-components'

import { toCSSValue } from '@loadsmart/miranda-tokens'
import type { ColorToken } from '@loadsmart/miranda-tokens'

const pulse = keyframes`
  from {
    transform: scale(1);
    opacity: 1;
  }

  to {
    transform: scale(2);
    opacity: 0;
  }
`

type StatusIndicatorProps = {
  readonly color?: ColorToken
}

export const StatusIndicator = styled.span<StatusIndicatorProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 8px;
  height: 8px;
  border-radius: ${toCSSValue('border-radius-circle')};
  background: ${({ color }) => toCSSValue(color ?? 'color-brand')};

  &:before {
    background: ${({ color }) => toCSSValue(color ?? 'color-brand')};
    content: '';
    display: block;
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: ${toCSSValue('border-radius-circle')};
    animation: ${pulse} 1.5s infinite ease-in;
  }
`
